import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mainNavigation: [
      { name: "Headphones", url: "/products/headphones" },
      { name: "Speakers", url: "/" },
      { name: "Soundbars", url: "/" },
      { name: "Sunglasses", url: "/" },
      { name: "Support", url: "/" },
    ],
    footer: {
      mainLinks: [
        [
          { name: "Headphones", url: "/products/headphones" },
          { name: "Speakers", url: "/" },
          { name: "Soundbars", url: "/" },
          { name: "Sunglasses", url: "/" },
          { name: "Sleepbuds", url: "/" },
          { name: "Hearphones", url: "/" },
        ],
        [
          { name: "Professional", url: "/" },
          { name: "Automotive", url: "/" },
          { name: "Aviation", url: "/" },
          { name: "Military", url: "/" },
          { name: "Work", url: "/" },
          { name: "Support", url: "/" },
        ],
        [
          { name: "Find a Store", url: "/" },
          { name: "About Bose", url: "/" },
          { name: "Work at Bose", url: "/" },
          { name: "Bose Partner Program", url: "/" },
          { name: "Bose Worldwide", url: "/" },
        ],
        [
          { name: "Beware of counterfeits", url: "/" },
          { name: "Sustainability at Bose", url: "/" },
          { name: "Accessibility", url: "/" },
        ],
      ],
      social: [],
      legal: [
        { name: "&copy; 2020 Bose Corporation", url: "/" },
        { name: "California Privacy Notice of Collection", url: "/" },
        { name: "Terms of Use", url: "/" },
        { name: "Terms of Sale", url: "/" },
        { name: "Cookies Notice", url: "/" },
        { name: "Trademarks", url: "/" },
      ],
      country: [],
    },
    theme: "theme-light",
    homePage: {
      mainBlade: {
        product: "Soundbar 700",
        header: "Feel every moment<br/> for the first time.",
        background: "landing-soundbar.png",
      },
      secondaryBlade: {
        product: "Headphones 700",
        header: "For those bold enough<br/> to change the game.",
        background: "landing-headphones.png",
      },
      tertiaryBlade: {
        product: "Home Speaker 500",
        header: `You've never heard<br/> a smart speaker like this.`,
        background: "landing-home-speaker-500.png",
      },
    },
    productsPage: {
      productBlades: [
        {
          product: "Headphones 700",
          copy: `The most capable headphones we've ever made. With 11 levels of noise cancellation, transparency mode, volume-optimized Ative EQ, unrivaled voice pick up and 20 hours of battery &mdash; it's ready to take on anything.`,
          cost: { normal: "399", reduced: "349" },
          background: "products/headphones-700.jpg",
          backgroundFill: "contain",
          imagePos: "100% 50%",
        },
        {
          product: "Quiet Comfort 45",
          copy:
            "Our world-class noise cancellation makes quiet sound quieter and your music sound better. And now with Google Assistant and Amazon Alexa built in, for instant access to millions of songs, playlists, and more.",
          cost: { normal: "349", reduced: "299" },
          background: "products/quietComfort-45_2.jpg",
          backgroundFill: "contain",
          align: "right",
          imagePos: "0 50%",
        },
      ],
      products: [
        {
          background: "products/soundSport.png",
          product: "SoundSport Wireless",
          cost: {
            normal: "149",
            reduced: "99",
          },
        },
        {
          background: "products/soundSportFree.png",
          product: "SoundSPort Free",
          cost: {
            normal: "199",
          },
        },
        {
          background: "products/qc20.png",
          product: "QuietComfort 20",
          cost: {
            normal: "199",
          },
        },
        {
          background: "products/sleepbuds.png",
          product: "Sleepbuds",
          cost: {
            normal: "249",
          },
        },
        {
          background: "products/hearphones.png",
          product: "Hearphones",
          cost: {
            normal: "499",
            reduced: "429",
          },
        },
        {
          background: "products/soundlink.png",
          product: "SoundLink Around-Ear",
          cost: {
            normal: "229.95",
          },
        },
        {
          background: "products/soundcomm.png",
          product: "SoundComm B40",
          cost: {
            normal: "749",
          },
          starting: true,
        },
        {
          background: "products/qc35LineUp.png",
          product: "Custom<br/>QuietComfort 35 II",
          cost: {
            normal: "399",
            reduced: "349",
          },
        },
        {
          background: "products/proflightS2.png",
          product: "ProFlight Series 2",
          cost: {
            normal: "995",
          },
          starting: true,
        },
        {
          background: "products/a20Aviation.png",
          product: "A20 Aviation",
          cost: {
            normal: "995",
          },
          starting: true,
        },
      ],
    },
    product: {
      info: {
        name: "QuietComfort Pro",
        price: {
          normal: "279",
        },
      },
      everyEar: {
        copy: {},
        images: [
          { src: "ear01.png", upClose: true },
          { src: "ear02.png", upClose: true },
          { src: "ear03.png", upClose: true },
          { src: "ear04.png", upClose: true },
          { src: "ear-mapping.webm", video: true },
          {
            src: "woman-purple-blue-bg-opaque-no-bud.png",
            full: true,
            scale: true,
          },
          { src: "woman-purple-blue-bg-opaque.jpg", full: true },
          { src: "woman-normal-bg-familyroom.jpg", full: true },
          { src: "woman-normal-bg-coffee.jpg", full: true },
        ],
      },
      moments: {
        headers: [
          { text: "For Every Moment" },
          { text: "For Everyday" },
          { text: "For Everyone" },
        ],
        images: {
          firstCol: [
            { src: "ocean.png" },
            { src: "working.png" },
            { src: "city-street.png" },
          ],
          lastCol: [
            { src: "work-from-home.png" },
            { src: "airport.png" },
            { src: "train-platform.png" },
          ],
        },
      },
      productNav: [
        { name: "Overview", url: "#overview" },
        { name: "Tech Specs", url: "#tech-spec" },
        { name: "Compare", url: "#compare" },
        { name: "FAQs", url: "#faq" },
      ],
      FAQ: [
        {
          header: "What's In The Box",
          class: "in-the-box",
        },
        {
          header: "Dimensions",
          class: "dimensions",
        },
        {
          header: "Materials",
          class: "materials",
        },
        {
          header: "Battery",
          class: "battery",
        },
        {
          header: "Microphone",
          class: "microphone",
        },
        {
          header: "Bluetooth",
          class: "bluetooth",
        },
        {
          header: "Input",
          class: "input",
        },
        {
          header: "Colors",
          class: "colors",
        },
        {
          header: "Control",
          class: "control",
        },
      ],
    },
  },
  mutations: {
    setTheme(state, theme) {
      const newTheme = theme === "dark" ? "theme-dark" : "theme-light";
      state.theme = newTheme;
    },
  },
  actions: {
    getAsset(context, url) {
      return require("@/assets/" + url);
    },
    setTheme(context, theme) {
      context.commit("setTheme", theme);
    },
  },
  modules: {},
});
